import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  IconButton, 
  Typography, 
  useTheme, 
  useMediaQuery,
  Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TwoFactorAuthSetup from './TwoFactorAuthSetup'; 

export default function TwoFactorNag() {
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector((state) => state.user.user);
  const isAuth = useSelector((state) => state.user.isAuth);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const shouldShow = isAuth && user && !user.two_factor_enabled;
    const hasBeenDismissed = sessionStorage.getItem('2faNagDismissed') === 'true';

    if (shouldShow && !hasBeenDismissed) {
      // Aumentiamo il ritardo per un'apparizione meno brusca
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [isAuth, user]);

  const handleClose = () => {
    sessionStorage.setItem('2faNagDismissed', 'true');
    setIsOpen(false);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog 
      open={isOpen} 
      onClose={handleClose} 
      fullScreen={isMobile}
      fullWidth 
      maxWidth="sm"
      slotProps={{
        paper: { sx: { borderRadius: isMobile ? 0 : 2 } }
      }}
    >
      <DialogTitle sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" component="div">
            Security Warning
          </Typography>
          <IconButton onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers sx={{ p: { xs: 2, sm: 3 } }}>
          <TwoFactorAuthSetup onSetupComplete={() => setIsOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}